/*global BMap */
import {
    myFingerprint,
    browserInfo,
    getAnimationEvent,
} from "@utils/browerHandle";


export const myConst = {
    appName: 'Wc', // 首字母大写
    cacheTime: 1 * 60 * 60 * 1000, // 本地缓存最大时间 体现在 marker 在地图上的定位
    loc: {
        watchCycle: 30 * 1000,
        timeout: 5 * 1000,
        maximumAge: 60 * 1000, // 可返还的最大定位年龄
    },
    minPinDis: 100, // 重新 pin marker 的最小距离
    maxShowInMap: browserInfo.versions.mobile ? 30 : 100, // marker 同时最大显示数量
    updateTimeout: 60 * 1000, // marker 点缓存最大时间 体现在 marker 上面是不是显示具体数量
    HIDE_MARKER_TEXT_LEVEL: 16,
    API_URL: '/api/wc', // todo
    // API_URL: location.host.startsWith('127.0.0.1') ? '//127.0.0.1:9999/parking' : '//api.zhuzhou.city/parking', // todo
    CDN_SERVER: '//cdn.bike.zhuzhou.city',
    fingerprint: myFingerprint(),
    isMobile: browserInfo.versions.mobile,
    mEvent: browserInfo.versions.mobile ? 'touchend' : 'click',
    animationEvent: getAnimationEvent(),
    markerHtml: `
        <div class="marker_icon" id="markerId_{{id}}_markerId" data-type="{{type}}">
            <div class="top {{res}} {{selected}} bg">
                <img class="topImg" src="{{imgBg}}" alt="">
                <span class="topText use">{{uCount}}</span>
                <span class="topText empty">{{eCount}}</span>
            </div>
            <div class="bottom marker_bottom">{{name}}</div>
        </div>`,
    infoHtml: `
        <div id="infoBox">
            <div class="top">
                <a id="infoBox_a" href="{{url}}" target="_blank">
                    <img id="infoBox_img" src="./static/img/pano_default.png" alt="pano_default"/>
                </a>
            </div>
            <div class="bottom">
                <div class="text">
                    <p id="infoBox_name" class="name mdui-typo-title"></p>
                    <div id="infoBox_info" class="info mdui-typo"></div>
                    <div class="numWrap">
                        <p class="num empt"><span class="title">空位</span><span id="infoBox_empty" class="loading">-</span></p>
                        <p class="num use"><span class="title">使用</span><span class="loading"><span id="infoBox_use">-</span></span></p>
                        <p class="num total"><span class="title">总计</span><span class="loading"></span><span id="infoBox_total">-</span></p>
                        <p class="num tel"><span class="title">☎️</span><span class="loading" id="infoBox_tel"><a href="tel:-">-</a></span></p>
                    </div>
                </div>
                <div id="sjx_down"></div>
            </div>
        </div>`,
    infoInfoHtml: `
            <div class="rule">
                <kbd class="title">{{title}}</kbd>
                <p class="content">{{content}}</p>
            </div>
        `,
    // infoInfoHtml: {
    //     [DATA_TYPE_STREET]: `
    //         <div class="rule">
    //             <kbd class="title">{{title}}</kbd>
    //             <p class="content">{{content}}</p>
    //         </div>
    //     `,
    //     [DATA_TYPE_PARKING]: `
    //         <div class="rule">
    //             <kbd class="title">{{title}}</kbd>
    //             <p class="content">{{content}}</p>
    //         </div>
    //     `,
    //     [DATA_TYPE_OIL]: ``,
    //     [DATA_TYPE_NEWENERGY]: ``,
    // },
};

export const myFn = {
    $$: window.mdui.JQ,
    init: '', // eslint-disable-line  map组件中赋值 函数
    pin: '', // eslint-disable-line  map组件中赋值 函数
};

export const myMap = {
    map: {}, // map initMap 赋值
    geolocation: {}, // map getMyLocInit 赋值
};

window.myMap = myMap;